import type { Auth0ContextInterface } from "@auth0/auth0-react";

import { Loader } from "@partners/ui";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import {
  createRootRouteWithContext,
  Outlet,
  ScrollRestoration,
} from "@tanstack/react-router";
import React, { Suspense } from "react";

import { ErrorComponent } from "@/components/Error";
import { UnauthenticatedHeader } from "@/components/Header";

export type MyRouterContext = {
  // The ReturnType of your useAuth hook or the value of your AuthContext
  auth: Auth0ContextInterface;
};

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null // Render nothing in production
  : React.lazy(() =>
      // Lazy load in development
      import("@tanstack/react-router-devtools").then((res) => ({
        default: res.TanStackRouterDevtools,
        // For Embedded Mode
        // default: res.TanStackRouterDevtoolsPanel
      })),
    );

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: () => (
    <>
      <main>
        <Outlet />
        <ScrollRestoration />
      </main>
      <Suspense>
        <TanStackRouterDevtools />
        <ReactQueryDevtools />
      </Suspense>
    </>
  ),
  errorComponent: ({ error }) => (
    <>
      <UnauthenticatedHeader />
      <ErrorComponent error={error} />
    </>
  ),
  pendingComponent: () => <Loader />,
});
